
import { Component, Prop, Vue } from 'vue-property-decorator';
import Themeable from 'vuetify/lib/mixins/themeable';
import { CommentInterface } from '@/services/QA/comment/interfaces';
import { UserBaseInfoInterface, UserRepoInterface } from '@/services/Users/Interfaces';

@Component({
  mixins: [
    Themeable,
  ],
  inject: [
    'userRepository',
  ],
})
export default class FeedbackCommentDialog extends Vue {
  @Prop() private title: string;
  @Prop() private comments: CommentInterface[];

  private loading: boolean = true;
  private visible: boolean = true;

  private userRepository!: UserRepoInterface;

  private usersMap: { [userId: string]: UserBaseInfoInterface } = {};

  private async created(): Promise<void> {
    await this.getAuthorsInfo();
    this.loading = false;
  }

  private async getAuthorsInfo(): Promise<void> {
    const ids: string[] = [];
    this.comments.forEach((comment) => {
      if (!ids.includes(comment.authorId)) {
        ids.push(comment.authorId);
      }
    });

    const users = await this.userRepository.getUsersByIds(ids);
    users.forEach((user) => {
      this.usersMap[user.id] = user;
    });
  }

  private destroyComponent(): void {
    this.visible = false;
    this.$emit('close');
  }
}
